import React, {Component} from 'react';




import { Stage, Layer, Rect, Line, Circle, Text, Arc } from "react-konva";
import Konva from "konva";

const colors = {
    "red" : "#f86c6b",
    "gray" : "#f0f3f5",
    "darkgray" : "#c2cfd6",
    "text" : "#536c79"
};

const offsets = {
    generator1 : {
        number : 1,
        width : 300
    },
    generator2 : {
        number : 2,
        width : 450
    },
    tie1: {
        number : 2,
        width : 150
    },
    tie2: {
        number : 2,
        width : 578
    },
    utility1: {
        number : 2,
        width : 22
    },
    utility2: {
        number : 2,
        width : 750
    }

};
const Generator = (props) =>  {
    const generatorLine = ((props.data.MeterVoltsAB + props.data.MeterVoltsBC + props.data.MeterVoltsCA) / 3) >= 100;
    return (
        <Layer>
            <Text
                x={offsets[props.gen]["width"] + 12}
                y={0}
                text={props.genname}
                fill={colors['text']}
                align="center"
            />
            <Circle
                x={offsets[props.gen]["width"] + 40}
                y={40}
                radius={20}
                fill={generatorLine ? colors['red'] : colors['gray']}
                stroke={generatorLine ? colors['red'] : colors['darkgray']}
                strokeWidth={3}
            />
            <Line
                points={[offsets[props.gen]["width"] + 40, 60, offsets[props.gen]["width"] + 40, 80]}
                stroke={generatorLine ? colors['red'] : colors['darkgray']}
                strokeWidth={4}
            />
            {
                // Busline Work
            }
            <Line
                points={[offsets[props.gen]["width"] + 40, 100, offsets[props.gen]["width"] + 40, 130]}
                stroke={props.hotbus ? colors['red'] : colors['darkgray']}
                strokeWidth={4}
            />
            <Line
                points={[offsets[props.gen]["width"] + -40, 130, offsets[props.gen]["width"] + 170, 130]}
                stroke={props.hotbus ? colors['red'] : colors['darkgray']}
                strokeWidth={4}
            />
            {
                // End Busline Work
            }

            <Arc
                x={offsets[props.gen]["width"] + (props.aux ? 39: 29)}
                y={90}
                fill={props.aux ? colors['red'] : colors['darkgray']}
                innerRadius={10}
                outerRadius={15}
                angle={180}
                rotation={90}
            />
            <Text
                x={offsets[props.gen]["width"] + 50}
                y={80}
                text={"52" + props.genabr}
                fill={colors['text']}
            />
            <Text
                x={offsets[props.gen]["width"] + 50}
                y={95}
                text={props.aux ? "Closed" : "Open"}
                fill={props.aux ? colors['red'] : colors['text']}
            />
            <Text
                x={offsets[props.gen]["width"] + 30}
                y={33}
                text={props.genabr}
                fill={generatorLine ? colors['gray'] : colors['darkgray']}
                fontSize={15}
                align="center"

            />
        </Layer>
    );
};



const Tie = (props) =>  {
    return (
        <Layer>
            <Line
                points={[offsets[props.tie]["width"] + 40, 80, offsets[props.tie]["width"] + 40, 60, offsets[props.tie]["width"] + 112, 60, offsets[props.tie]["width"] + 112, 130]}
                stroke={props.mirror ? props.utilhotbus ? colors['red'] : colors['darkgray'] : props.genhotbus ? colors['red'] : colors['darkgray']}
                strokeWidth={4}
            />
            <Line
                points={[offsets[props.tie]["width"] + 40, 100, offsets[props.tie]["width"] + 40, 130]}
                stroke={props.mirror ? props.genhotbus ? colors['red'] : colors['darkgray'] : props.utilhotbus ? colors['red'] : colors['darkgray']}
                strokeWidth={4}
            />
            <Arc
                x={offsets[props.tie]["width"] + (props.aux ? 39: 29)}
                y={90}
                fill={props.aux ? colors['red'] : colors['darkgray']}
                innerRadius={10}
                outerRadius={15}
                angle={180}
                rotation={90}
            />
            <Text
                x={offsets[props.tie]["width"] + 50}
                y={80}
                text={"52" + props.tieabr}
                fill={colors['text']}
            />
            <Text
                x={offsets[props.tie]["width"] + 50}
                y={95}
                text={props.aux ? "Closed" : "Open"}
                fill={props.aux ? colors['red'] : colors['text']}
            />



        </Layer>
    );
};

const Utility = (props) =>  {
    let compensation = 8;
    const utilityLine = ((props.data.MeterVoltsAB + props.data.MeterVoltsBC + props.data.MeterVoltsCA) / 3) >= 100;
    return (
        <Layer>
            {
                //begin utility xformer
            }
            <Arc
                x={offsets[props.utility]["width"] + 10 + compensation}
                y={30}
                fill={utilityLine ? colors['red'] : colors['darkgray']}
                innerRadius={5}
                outerRadius={10}
                angle={180}
                rotation={0}
            />
            <Arc
                x={offsets[props.utility]["width"] + 25 + compensation}
                y={30}
                fill={utilityLine ? colors['red'] : colors['darkgray']}
                innerRadius={5}
                outerRadius={10}
                angle={180}
                rotation={0}
            />
            <Arc
                x={offsets[props.utility]["width"] + 40 + compensation}
                y={30}
                fill={utilityLine ? colors['red'] : colors['darkgray']}
                innerRadius={5}
                outerRadius={10}
                angle={180}
                rotation={0}
            />
            <Arc
                x={offsets[props.utility]["width"] + 55 + compensation}
                y={30}
                fill={utilityLine ? colors['red'] : colors['darkgray']}
                innerRadius={5}
                outerRadius={10}
                angle={180}
                rotation={0}
            />


            <Arc
                x={offsets[props.utility]["width"] + 10 + compensation}
                y={55}
                fill={utilityLine ? colors['red'] : colors['darkgray']}
                innerRadius={5}
                outerRadius={10}
                angle={180}
                rotation={180}
            />
            <Arc
                x={offsets[props.utility]["width"] + 25 + compensation}
                y={55}
                fill={utilityLine ? colors['red'] : colors['darkgray']}
                innerRadius={5}
                outerRadius={10}
                angle={180}
                rotation={180}
            />
            <Arc
                x={offsets[props.utility]["width"] + 40 + compensation}
                y={55}
                fill={utilityLine ? colors['red'] : colors['darkgray']}
                innerRadius={5}
                outerRadius={10}
                angle={180}
                rotation={180}
            />
            <Arc
                x={offsets[props.utility]["width"] + 55 + compensation}
                y={55}
                fill={utilityLine ? colors['red'] : colors['darkgray']}
                innerRadius={5}
                outerRadius={10}
                angle={180}
                rotation={180}
            />
            {
                //end utility xformer
            }
            <Line
                points={[offsets[props.utility]["width"] + 40, 50, offsets[props.utility]["width"] + 40, 80]}
                stroke={utilityLine ? colors['red'] : colors['darkgray']}
                strokeWidth={4}
            />
            {
                //bus
            }
            <Line
                points={[offsets[props.utility]["width"] + 40, 100, offsets[props.utility]["width"] + 40, 130, offsets[props.utility]["width"] + (props.mirror ? -62 : 170), 130]}
                stroke={props.utilhotbus ? colors['red'] : colors['darkgray']}
                strokeWidth={4}
            />
            <Arc
                x={offsets[props.utility]["width"] + (props.aux ? 39: 29)}
                y={90}
                fill={props.aux ? colors['red'] : colors['darkgray']}
                innerRadius={10}
                outerRadius={15}
                angle={180}
                rotation={90}
            />
            <Text
                x={offsets[props.utility]["width"] + 50}
                y={80}
                text={"52" + props.utilityabr}
                fill={colors['text']}
            />
            <Text
                x={offsets[props.utility]["width"] + 50}
                y={95}
                text={props.aux ? "Closed" : "Open"}
                fill={props.aux ? colors['red'] : colors['text']}
            />

        </Layer>
    );
};



function avgBusMetering(name,aux,data) {
    let average = (data[name][0].MeterVoltsAB + data[name][0].MeterVoltsBC + data[name][0].MeterVoltsCA) / 3;
    return (average >= 100) && aux;
}


class Oneline extends Component {
    constructor(props) {
        super(props);
        this.state = {
            color: "green"
        };
    }
    render() {
        let { data } = this.props;
        //const hotbus2 = data['generator1'][0].MeterVoltsAB >= 100;
        let hotBusGen = avgBusMetering("generator1",data['systemStatus2'][4],data) ||
            avgBusMetering("generator2",data['systemStatus2'][5],data);
        let hotBusUtil1 = avgBusMetering("utility1",data['systemStatus2'][0],data);
        let hotBusUtil2 = avgBusMetering("utility2",data['systemStatus2'][2],data);
        let tie1Aux = data['systemStatus2'][1];
        let tie2Aux = data['systemStatus2'][3];

        if ((hotBusUtil1 && tie1Aux) || (hotBusUtil2 && tie2Aux)) {
            hotBusGen = true;
        }
        if (hotBusGen && tie1Aux) {
            hotBusUtil1 = true;
        }
        if (hotBusGen && tie2Aux) {
            hotBusUtil2 = true;
        }
        let windowWidth = this.props.innerWidth;
        let screenOffsetX = 0;
        if (windowWidth >= 1600) { screenOffsetX = -320; }
        else if (windowWidth >= 1360) { screenOffsetX = -220; }
        else if (windowWidth >= 1200) { screenOffsetX = -140; }
        else if (windowWidth >= 1000) { screenOffsetX = -80; }
        return (
            <Stage width={windowWidth} height={200} draggable={true} offsetX={screenOffsetX} offsetY={-40} scaleX={this.props.overViewZoomLevel} scaleY={this.props.overViewZoomLevel}>
                <Generator aux={data['systemStatus2'][4]} gen="generator1" genname="Generator 1" genabr="G1" data={data['generator1'][0]} hotbus={hotBusGen} />
                <Generator aux={data['systemStatus2'][5]} gen="generator2" genname="Generator 2" genabr="G2" data={data['generator2'][0]} hotbus={hotBusGen}/>
                <Tie aux={tie1Aux} tie="tie1" tienname="Bus Tie 1" tieabr="BT1" genhotbus={hotBusGen} utilhotbus={hotBusUtil1} mirror={0}/>
                <Tie aux={tie2Aux} tie="tie2" tienname="Bus Tie 2" tieabr="BT2" genhotbus={hotBusGen} utilhotbus={hotBusUtil2} mirror={1}/>
                <Utility aux={data['systemStatus2'][0]} utility="utility1" utilityname="Utility 1" utilityabr="N1" data={data['utility1'][0]} utilhotbus={hotBusUtil1} mirror={0}/>
                <Utility aux={data['systemStatus2'][2]} utility="utility2" utilityname="Utility 2" utilityabr="N2" data={data['utility2'][0]} utilhotbus={hotBusUtil2} mirror={1}/>
            </Stage>
        );
    }
}


export default Oneline;



// WEBPACK FOOTER //
// ./src/views/site/Overview/Oneline.js